import queryString from 'query-string';

export const parse = (string) => queryString.parse(string);

export const stringify = (parsed) => queryString.stringify(parsed);
